import { useState } from "react";
import { Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useProfile } from "@/context/ProfileContext";
import { errorMessage } from "@/lib/api";
import { TrackList } from "./TrackCard";
import { TrackEditDialog } from "./TrackEditDialog";

export const ManageTracks = ({ tracks, setTracks }) => {
  const { request, refresh } = useProfile();
  const [editing, setEditing] = useState(null);
  const [deleting, setDeleting] = useState(null);

  const remove = async () => {
    try {
      await request("delete", `/tracks/${deleting.id}`);
      setTracks((ts) => ts.filter((t) => t.id !== deleting.id));
      refresh();
      toast.success("Track removed");
    } catch (err) { toast.error(errorMessage(err)); } finally { setDeleting(null); }
  };

  return (
    <>
      <TrackList tracks={tracks} empty="You haven't uploaded any tracks yet." renderActions={(t) => (
        <div className="flex gap-1">
          <button data-testid={`track-edit-${t.id}`} onClick={() => setEditing(t)} aria-label="Edit track" className="p-1.5 text-slate-400 hover:text-white transition-colors"><Pencil className="h-4 w-4" /></button>
          <button data-testid={`track-delete-${t.id}`} onClick={() => setDeleting(t)} aria-label="Delete track" className="p-1.5 text-slate-400 hover:text-nw-red transition-colors"><Trash2 className="h-4 w-4" /></button>
        </div>
      )} />
      <TrackEditDialog track={editing} onClose={() => setEditing(null)} onSaved={(u) => { setTracks((ts) => ts.map((t) => (t.id === u.id ? u : t))); setEditing(null); }} />
      <AlertDialog open={!!deleting} onOpenChange={(o) => !o && setDeleting(null)}>
        <AlertDialogContent className="bg-nw-bg2 border-white/10 text-slate-100 max-w-[92vw] sm:max-w-md rounded-2xl">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete “{deleting?.title}”?</AlertDialogTitle>
            <AlertDialogDescription className="text-slate-400">The track will be removed from NEW WAVE.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="track-delete-cancel" className="bg-transparent border-white/15 text-slate-200 hover:bg-white/5 hover:text-white">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="track-delete-confirm" onClick={remove} className="bg-nw-red hover:bg-red-700 text-white">Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
